export class AlertConfig {
	public alertTriggers: any[] = [];
	public alertFrequency: any = { name: '', id: 0 };
	public alertDays: any[] = [];
	public alertTime = '';
	public alertTimeUTC = '';
	public mfilesId = -1;
}